import * as React from 'react';
import { Button, Typography, Select, MenuItem, FormControl, InputLabel, FormControlLabel, Checkbox, TextField } from '@material-ui/core';
import { IInterface, IEquipmentManifest, IInterfaceWashEquipment, IInterfaceWashEquipmentPlan, IInterfaceTrigger, IEquipment } from '../_types/location';
import { EnumToString } from '../_util/Utility';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Icon, { SupportedIcons } from '../common/Icon';
import EquipmentInterface from './_equipment_interface';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useState } from 'react';

interface Props {
    classes: any;
    /** the item to display */
    item: IInterface;
    manifest: IEquipmentManifest;
    /** raised when control is clicked */
    onSelect: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onCancel: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onSave: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onChange: (iface:IInterface) => void;
    onDelete: (id: number | null) => void;
};

// LEARN
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    formWidth: {
        width: '44em',
        textAlign: "center",
    }
}));

// const getDisplayText = (itm: IInterface) => {
//     let toReturn: string = EnumToString(itm.interface_type_cn || "");

//     if (itm.provider_name && itm.provider_name.length > 0) {
//         toReturn += " - " + itm.provider_name;
//     }

//     if (itm.interface_type_cn !== "interfacetype.attendant") {
//         toReturn += " (" + itm.triggers.map((e => EnumToString(e.trigger_cn))).join(',') + ")";
//     }

//     return toReturn;
// }



const renderProviderName = (itm: IInterface) => {
    if (itm.provider_name) {
        return (
            <Grid item>
            <Chip style={{marginLeft: "3px"}} color="primary" variant="outlined" size="small" label={itm.provider_name}/>
            </Grid>
        )
    }
}

const renderTriggers = (itm: IInterface) => {
 
    if (itm.interface_type_cn !== "interfacetype.attendant") {
        return ( 
            <Grid item>
                {itm.triggers.map((e) => {
                    return (<Chip style={{marginLeft: "3px"}} color="secondary" variant="outlined" size="small" label={EnumToString(e.trigger_cn)}></Chip>)
                })}
            </Grid> 
        );
    } else { return ""; }

}

const renderModel = (itm: IInterface) => {
    if (!itm.model || itm.model.length === 0) {
        return "";
    }

    if (itm.provider_name) {
        return (
            <Grid item>
            <Chip style={{marginLeft: "3px"}} color="default" variant="outlined" size="small" label={itm.model}/>
            </Grid>
        )
    }
}

const InterfaceDisplayItem: React.FC<Props> = (prop: Props) => {
    const [deleteConfirmOpen, setDeleteConfirmDialog] = useState<boolean>(false);
    const [matchText, setMatchText] = useState<string>('');

    let ChangeMatchText = function (e: { target: { value: React.SetStateAction<string>; }; }) {
        setMatchText(e.target.value);
    }

    let CancelDelete = function (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        setDeleteConfirmDialog(false);        
        setMatchText('');
    }

    let SubmitDelete = function () {
        setDeleteConfirmDialog(false);        
        setMatchText('');
        prop.onDelete(prop.item.id);
    }

    const _addEquipment = () => {
        let toAdd: IInterfaceWashEquipment = {
            id: 0,
            interface_id: prop.item.id || 0,
            plans: [],
            qrcode: "",
            text_code: "",
            remote_config: "",
            washequipment_id: 0
        };
        prop.item.equipment.unshift(toAdd);
        prop.onChange(prop.item);
    }
    

    const getPlanPrice = (itm: IInterfaceWashEquipmentPlan) => {
        let price = itm.price;
        if (price === 0) {
            let origPlan = prop.manifest.plans.find(p => p.service_plan_id === itm.service_plan_id);
            if (origPlan) {
                price = origPlan.price;
            }
        }

        return price;
    }
    const homeIcon = (itm: IInterfaceWashEquipmentPlan, equip: IEquipment | undefined) => {
        let plan = prop.manifest.plans.find(i => i.service_plan_id === itm.service_plan_id); 
        let home = (plan?.service_location_id === equip?.service_location_id);
        let color = home ? "primary" : "disabled";
        
        return (
            <span style={{display:"inline-flex"}}>
                <Icon fontSize="small" iconName={SupportedIcons.Home} color={color} />
                { !home && ( <span style={{fontStyle:"italic",marginRight:"3px"}}>{plan?.location_name}</span> ) }
            </span>
        );
    }

    const _isTriggerEnabled = (trigger_cn: string): boolean => {
        let current = prop.item.triggers.find(g => g.trigger_cn === trigger_cn);
        return (current !== undefined && !current.delete);
    }

    const _setTrigger = (trigger_cn: string, status: boolean) => {

        let current = prop.item.triggers.find(g => g.trigger_cn === trigger_cn);

        if (current) {
            if (status) {
                current.delete = false;
                prop.onChange(prop.item);
            } else {
                if (current.id === 0) {
                    let idx = prop.item.triggers.findIndex(g => g.trigger_cn === trigger_cn);
                    prop.item.triggers.splice(idx);

                } else {
                    current.delete = true;
                }
                prop.onChange(prop.item);
            }
        } else {
            if (status) {
                let newTrigger: IInterfaceTrigger = {
                    delete: false,
                    id: 0,
                    interface_id: prop.item.id || 0,
                    trigger_cn: trigger_cn
                };
                prop.item.triggers.push(newTrigger);
                prop.onChange(prop.item);
            }
        }

    }

    const classes = useStyles();
    
    return (
        <React.Fragment>
            <Dialog className={classes.formControl} open={deleteConfirmOpen}>
                <DialogTitle className={classes.formWidth}>Delete Confirmation</DialogTitle>
                <DialogContent>
                    <div> 
                        Please type the word <b> delete </b> to confirm deletion.
                    </div>
                    <TextField id="matchText" 
                        label="delete" 
                        value={matchText} 
                        onChange={ChangeMatchText} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={(event) => CancelDelete(event)}>Cancel</Button>
                    <Button onClick={SubmitDelete} 
                        disabled={matchText.toLowerCase() !== 'delete'}>Confirm</Button>
                </DialogActions>
            </Dialog>
        <Grid item>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <Button onClick={prop.onSelect}>{EnumToString(prop.item.interface_type_cn)}</Button>
                </Grid>
                { renderProviderName(prop.item) }
                { renderTriggers(prop.item) }
                { renderModel(prop.item) }
                <Grid item>{ prop.item.selected && (<IconButton size="small" onClick={(e)=>{prop.item.editing=true; prop.onChange(prop.item)}}><Icon fontSize="small" iconName={SupportedIcons.Edit}/></IconButton>) }</Grid>
            </Grid>
        </Grid>
        <Grid item style={{marginLeft: "10px"}}>
            { prop.item.equipment.map((e) => {                                
                let equip = prop.manifest.equipment.find(g => g.id === e.washequipment_id);
     
                return ( 
                <React.Fragment>
                    <div>{equip?.name + ' - ' + (e.qrcode || "No QR Code") + ' - ' + (e.text_code || "No Text Code")}</div>
                    <div style={{marginLeft: "10px"}}>
                        {
                        e.plans.map((p) => {
                            let plan = prop.manifest.plans.find(i => i.service_plan_id === p.service_plan_id);
                       
                            if (!p.deleted && !plan?.deleted) {
                                return (
                                    <span style={{display:"inline-flex", marginRight: "15px"}}>
                                    {homeIcon(p, equip)} 
                                    <span>{'"' + plan?.service_plan_name + '" - ' + getPlanPrice(p)}</span><br/>
                                    </span>
                                )
                            } else {
                                return (<span></span>)
                            }
                        }) 
                        }
                    </div>
                </React.Fragment>)
                
            }) }
        </Grid>
        
        {prop.item.editing && (
        <Dialog maxWidth="lg" scroll="paper" open={true}>
            <DialogTitle>Add/Edit Interface</DialogTitle>
            <DialogContent>
            <Grid item>
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                    <FormControl className={classes.formControl}>
                            <InputLabel id="type-select-label">Type</InputLabel>
                            <Select
                            labelId="type-select-label"
                            id="type-select"
                            value={prop.item.interface_type_cn}
                            onChange={(e) => {let i = prop.item; i.interface_type_cn = e.target.value as string; prop.onChange(i)}}
                            >
                            <MenuItem value="interfacetype.attendant">{EnumToString("interfacetype.attendant")}</MenuItem>
                            <MenuItem value="interfacetype.paystation">{EnumToString("interfacetype.paystation")}</MenuItem>
                            <MenuItem value="interfacetype.unit">{EnumToString("interfacetype.unit")}</MenuItem>

                            </Select>
                        </FormControl>
                    </Grid>
                    { prop.item.interface_type_cn !== "interfacetype.attendant" && ( 
                        <>
                            <Grid item>
                                <FormControl className={classes.formControl}>
                                    <InputLabel id="provider-select-label">Provider</InputLabel>
                                    <Select
                                        labelId="provider-select-label"
                                        id="provider-select"
                                        value={prop.item.provider_name}
                                        onChange={(e) => {let i = prop.item; i.provider_name = e.target.value as string; prop.onChange(i)}}
                                    >
                                        <MenuItem value="washify">{EnumToString("Washify")}</MenuItem>
                                        <MenuItem value="cryptopay">{EnumToString("Cryptopay")}</MenuItem>
                                        <MenuItem value="drb">{EnumToString("DRB")}</MenuItem>
                                        <MenuItem value="touch4wash">{EnumToString("Touch 4 Wash")}</MenuItem>
                                        <MenuItem value="coinless">{EnumToString("Coinless")}</MenuItem>
                                        <MenuItem value="unitec">{EnumToString("Unitec")}</MenuItem>
                                        <MenuItem value="washcard">{EnumToString("Washcard")}</MenuItem>
                                        <MenuItem value="xpreswash">{EnumToString("XpresWash")}</MenuItem>
                                        <MenuItem value="nayax">Nayax</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <InputLabel id="model-input-label">Model</InputLabel>
                                <TextField
                                    id="model-input"
                                    value={prop.item.model || ''}
                                    onChange={(e) => {let i = prop.item; i.model = e.target.value; prop.onChange(i)}}
                                    InputLabelProps={{ shrink: true }}
                                    placeholder="Enter model name"
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
                {prop.item.interface_type_cn !== "interfacetype.attendant" && (
                <Grid item>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <FormControlLabel label={EnumToString("interfacetrigger.remotescan")} control={
                                <Checkbox 
                                    checked={_isTriggerEnabled("interfacetrigger.remotescan")} 
                                    onChange={(evt) => _setTrigger("interfacetrigger.remotescan", evt.target.checked)}                                
                                />
                            }/>
                        </Grid>
                        <Grid item>
                            <FormControlLabel label={EnumToString("interfacetrigger.scanner")} control={
                                <Checkbox 
                                    checked={_isTriggerEnabled("interfacetrigger.scanner")}   
                                    onChange={(evt) => _setTrigger("interfacetrigger.scanner", evt.target.checked)}                                  
                                />
                            }/>
                        </Grid>
                        <Grid item>
                            <FormControlLabel label={EnumToString("interfacetrigger.finger")} control={
                                <Checkbox 
                                    checked={_isTriggerEnabled("interfacetrigger.finger")} 
                                    onChange={(evt) => _setTrigger("interfacetrigger.finger", evt.target.checked)}                                    
                                />
                            }/>
                        </Grid>
                    </Grid>
                </Grid>
                )}
                <Grid item>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <Typography>Equipment</Typography>
                        </Grid>
                      
                        <Grid item>
                           <IconButton 
                            disabled={prop.item.equipment.length >= prop.manifest.equipment.length} 
                            onClick={() => {_addEquipment()}}>
                               <Icon iconName={SupportedIcons.AddBox}/>
                            </IconButton>
                        </Grid>
                        
                    </Grid>
                    
                </Grid>
                <Grid item>
                    <Grid container direction="column">
                        {/* Each Associated Equipment... usually only one */}
                        {prop.item.equipment.map(e => {
                            return (
                                <EquipmentInterface classes={classes} item={e} manifest={prop.manifest} onCancel={(evt) => {}} onChange={() => prop.onChange(prop.item)} onSave={() => {}}  />
                            )
                        })}
                    </Grid>
                </Grid>
            </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={prop.onCancel}>Cancel</Button>
                <Button onClick={() => setDeleteConfirmDialog(true)}>Delete</Button>
                <Button onClick={prop.onSave}>Save</Button>
            </DialogActions>
            </Dialog> )}
        </React.Fragment>
    )
}

export default InterfaceDisplayItem;
